module.exports = __webpack_public_path__ + "img/adv.37518c35.png";